module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAOVBMVEUAAADqPD7qOz/vP0DqOz3rPD7qOz7qPD3pOz7qPD7qOz7qPT/qOz3qPD3pPD3rPT/tO0H/RkbpOz36jkSnAAAAEnRSTlMA5Ekd3V2eqphzYjzy0Lx+Kwtw+iurAAAAbElEQVQoz63QSw7DIAwA0XFISz79+v6HbSW28WyS2VkWPAHnyn/N1xvSLTtSy8Cas2icu5frPvCqdeBVu+NfDH+C4QsYvvnLPyD4Awx/geGrf3sDwd8g+AJU+Nx3rmuKmA6nUWRGMclaLj/fD/9IGxUTc5duAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/carticon.png
// module id = HDmw
// module chunks = 1